import React, {useState} from 'react';
import {Tabs} from '@udemy-v2/react-structure-components';
import {useClpPurchaseContext} from '../../context/clp-purchase-context.react-component';

import styles from './course-sidebar-tabs-container.module.scss';
import {publishEvent} from '@udemy-v2/event-tracking';
import {ClickEvent, LearningProduct} from '../../events/events';
import {useClpCourse} from '../../context/clp-course-provider.react-component';
import {CourseContentPlacement} from '@/features/course-landing-page/course-landing-page.react-component';
import {useI18n} from '@udemy-v2/i18n';
import {observer} from 'mobx-react';

export enum SidebarTabType {
    PERSONAL = 'personal',
    TEAMS = 'teams',
}

interface CourseSidebarTabsContainerProps {
    personalContent: React.ReactNode;
    teamsContent: React.ReactNode;
    placement: CourseContentPlacement;
}

/**
 * Internal component for CourseSidebarTabsContainer
 */
function CourseSidebarTabsContainerInternal({
    personalContent,
    teamsContent,
    placement,
}: CourseSidebarTabsContainerProps) {
    const {activeSidebarTab, setActiveSidebarTab} = useClpPurchaseContext();
    const [hasClickedTeamsTab, setHasClickedTeamsTab] = useState(false);
    const course = useClpCourse();
    const {gettext} = useI18n();

    const handleTabSelect = (tabId: unknown) => {
        setActiveSidebarTab(tabId as SidebarTabType);
        if (tabId === SidebarTabType.TEAMS && !hasClickedTeamsTab) {
            publishEvent(
                new ClickEvent({
                    componentName: 'TeamsPurchaseContent',
                    trackingId: course.id,
                    relatedObjectType: LearningProduct.COURSE,
                    relatedObjectId: Number(course.id),
                }),
            );
            setHasClickedTeamsTab(true);
        }
    };

    return (
        <Tabs activeTabId={activeSidebarTab} onSelect={handleTabSelect} fullWidth={true}>
            <Tabs.Tab id={SidebarTabType.PERSONAL} title={gettext('Personal')}>
                {personalContent}
            </Tabs.Tab>
            <Tabs.Tab id={SidebarTabType.TEAMS} title={gettext('Teams')}>
                <div
                    className={
                        placement === CourseContentPlacement.SIDEBAR
                            ? styles['sidebar-teams-tab-container']
                            : ''
                    }
                >
                    {teamsContent}
                </div>
            </Tabs.Tab>
        </Tabs>
    );
}

export const CourseSidebarTabsContainer = observer(CourseSidebarTabsContainerInternal);
